import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

const OFFER = 'offer';
const BRAND = 'brand';
const HAPPENING = 'happening';
const MESSAGE = 'message';
const MALL = 'mall';
const SETTING = 'setting';

export default class ImageUploader extends Component {
  static propTypes = {
    onUploaded: PropTypes.func.isRequired,
    source: PropTypes.string,
    type: PropTypes.oneOf([OFFER, BRAND, HAPPENING, MESSAGE, MALL, SETTING])
      .isRequired,
    cover: PropTypes.bool,
  };

  state = {
    source: this.props.source,
  };

  handleDropAccepted = ([file, ..._rest]) => {
    this.setState({ source: file.preview });
    this.props.onUploaded(file);
  };

  render() {
    const { type } = this.props;

    return (
      <Dropzone
        className={`${type}-image-upload-dropzone image-upload-dropzone`}
        onDropAccepted={this.handleDropAccepted}
        accept={'image/png,image/jpg,image/jpeg'}
        maxSize={1024 * 1024 * 50}
        multiple={false}
      >
        {this.renderPreview()}
      </Dropzone>
    );
  }

  renderPreview() {
    const { cover } = this.props;
    const { source } = this.state;

    if (!source) {
      return (
        <p>Try dropping some files here, or click to select files to upload.</p>
      );
    } else if (cover) {
      return (
        <div className="image-preview-wrapper">
          <div
            className="image-preview"
            style={{ backgroundImage: `url("${source}")` }}
          />
        </div>
      );
    } else {
      return <img src={source} />;
    }
  }
}
